import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  Container,
  label,
  MenuItem,
  useTheme,
  useMediaQuery,
  CircularProgress, FormControl, FormGroup, FormControlLabel, Checkbox, FormHelperText,
} from "@mui/material";



import PageLayout from "../../../../examples/LayoutContainers/PageLayout";
import HomeNavbar from "../../../../examples/Navbars/HomeNavbar";
import { url, urlLive } from "../../../../constant";

// const countries = [
//   { name: "India", code: "IN", dial_code: "+91", label: "🇮🇳 +91" },
//   { name: "United States", code: "US", dial_code: "+1", label: "🇺🇸 +1" },
//   { name: "United Kingdom", code: "GB", dial_code: "+44", label: "🇬🇧 +44" },
//   { name: "Australia", code: "AU", dial_code: "+61", label: "🇦🇺 +61" },
//   { name: "Canada", code: "CA", dial_code: "+1", label: "🇨🇦 +1" },
//   { name: "Germany", code: "DE", dial_code: "+49", label: "🇩🇪 +49" },
//   { name: "France", code: "FR", dial_code: "+33", label: "🇫🇷 +33" },
//   { name: "Brazil", code: "BR", dial_code: "+55", label: "🇧🇷 +55" },
// ];

// European country list

const countries = [
  { name: "United Kingdom", code: "GB", dial_code: "+44", label: "🇬🇧 +44" },
  { name: "Germany", code: "DE", dial_code: "+49", label: "🇩🇪 +49" },
  { name: "France", code: "FR", dial_code: "+33", label: "🇫🇷 +33" },
  { name: "Italy", code: "IT", dial_code: "+39", label: "🇮🇹 +39" },
  { name: "Spain", code: "ES", dial_code: "+34", label: "🇪🇸 +34" },
  { name: "Netherlands", code: "NL", dial_code: "+31", label: "🇳🇱 +31" },
  { name: "Belgium", code: "BE", dial_code: "+32", label: "🇧🇪 +32" },
  { name: "Sweden", code: "SE", dial_code: "+46", label: "🇸🇪 +46" },
  { name: "Austria", code: "AT", dial_code: "+43", label: "🇦🇹 +43" },
  { name: "Portugal", code: "PT", dial_code: "+351", label: "🇵🇹 +351" }
];



const CustomSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    phone: '',
    dial_code: '+39',
    privacyAccepted: false,      // mandatory checkbox
    marketingConsent: false,     // optional checkbox
  });

  const [sectionContent, setSectionContent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [contactContent, setContactContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);   


  const [errors, setErrors] = useState({});

  const [serverMessage, setServerMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' | 'error'

  // useEffect(() => {
  //   fetch(`${url}auth/section`)
  //     .then((res) => {
  //       if (!res.ok) {
  //         throw new Error(`HTTP error! Status: ${res.status}`);
  //       }
  //       return res.json();
  //     })
  //     .then((data) => {
  //       setSectionContent(data);
  //       // console.log('data:', data);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // }, []);


  useEffect(() => {
    fetchContactContent();
  }, []);

  const fetchContactContent = () => {
    setIsLoading(true);
    fetch(`${url}auth/contact-form-content`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch contact form content');
        }
        return response.json();
      })
      .then((data) => {
        setContactContent(data);
        console.log('contact-form', data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };


  useEffect(() => {
    if (serverMessage) {
      const timer = setTimeout(() => {
        setServerMessage('');
        setMessageType('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [serverMessage]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));

  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: '',
  //   }));
  // };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name) newErrors.name = 'Compila il campo richiesto.';
    if (!formData.surname) newErrors.surname = 'Compila il campo richiesto.';
    if (!formData.email) newErrors.email = 'Compila il campo richiesto.';
    if (!formData.phone) newErrors.phone = 'Compila il campo richiesto.';
    // ✅ Add this line for mandatory checkbox
    if (!formData.privacyAccepted) newErrors.privacyAccepted = 'Devi accettare la privacy policy.';

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
    } else {
      // Submit logic here
      // console.log('Form submitted:', formData);

      setLoading(true); // start loader if you have one

      try {
        const response = await fetch(`${url}auth/lead`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add authorization headers here if needed
          },
          body: JSON.stringify(formData),
        });

        const result = await response.json();

        if (response.ok) {
          console.log('Lead created successfully:', result);
          // Optionally reset form
          setFormData({
            name: '',
            surname: '',
            email: '',
            phone: '',
            dial_code: '+39',
            privacyAccepted: false,      // mandatory checkbox
            marketingConsent: false,     // optional checkbox
          });

          // setServerMessage('✅ Lead created and email sent successfully!');
          setServerMessage('✅ Email inviata correttamente!');

          setMessageType('success');

        } else {
          console.log('Submission failed:', result);
          setServerMessage('⚠️ Lead created, but email could not be sent.');
          setMessageType('error');
        }
      } catch (error) {

        console.error('Network or server error:', error);
        setServerMessage('❌ Server error. Please try again later.');
        setMessageType('error');

      } finally {
        setLoading(false);
      }



    }

  };


  return (
    <PageLayout>


      {/* <Box sx={{ background: '#fff', height: '110px', position: 'relative' }}>
      </Box>   */}

      <Container>
        <Box
          // mt={10}
          mt={{ xs: 6, sm: 8, md: 10 }}
          mb={{ xs: 9 }}
          sx={{
            // minHeight: "77vh",
            minHeight: { xs: '60vh', sm: '70vh', md: '77vh' },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#F5F8FF",  // #EFF1F4 #f5f8ff #F5F8FF
            boxShadow: 1,
            borderRadius: 2,
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 4, sm: 8, md: 8 },
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",           // fixed height
              // maxWidth: 1100,
              // backgroundColor: "#f7f9fc",
              // remove borderRadius here so parent is square
              // borderRadius: 3,
              // boxShadow: 3,
              p: { xs: 3, sm: 5, md: 6 },
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 4, md: 6 },
            }}
          >
            {/* Left Content */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                textAlign: { xs: "center", md: "left" },
                pt: 0,
              }}
            >
              <Typography
                variant={isMobile ? "h5" : "h4"}
                fontWeight="bold"
                mt={-3}
                mb={1}
              >
                {/* Join Our Community */}

                {contactContent?.title || ""}
              </Typography>
              <Typography variant="body1" color="text.secondary" lineHeight={1.6}>
                {/* Discover a world of opportunities by joining our platform. Fill in your
                details to get started. We're excited to have you onboard. */}
                {contactContent?.content || ""}
              </Typography>
            </Box>

            {/* Right Form with rounded corners */}
            <Box
              sx={{
                flex: 1,
                backgroundColor: "#FFFFFF",  // #183759 
                borderRadius: 3,
                boxShadow: 3,
                // minHeight: 550,
                p: { xs: 3, sm: 4 },
              }}
              mt={-3}
            >
              <Grid container spacing={5}>

                {/* First Name */}
                <Grid item xs={12} sm={6}>
                  <label
                    htmlFor="first-name"
                    style={{ color: '#000', fontSize: '14px', marginBottom: '4px', display: 'block' }}
                  >
                    {/* First Name */}
                    Nome
                  </label>
                  <TextField
                    id="first-name"
                    fullWidth
                    variant="outlined"
                    size="medium"
                    InputLabelProps={{ shrink: false }}
                    // placeholder="Enter your first name"
                    placeholder="Inserisci il tuo Nome"
                    // label="Nome"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    FormHelperTextProps={{
                      sx: { fontSize: '0.67rem' }, // 👈 Smaller font size
                    }}
                    sx={{
                      input: { color: '#000' },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '' },
                        '&:hover fieldset': { borderColor: '' },
                        '&.Mui-focused fieldset': { borderColor: '#82a2ff' },
                      },
                    }}
                  />
                </Grid>

                {/* Last Name */}
                <Grid item xs={12} sm={6}>
                  <label
                    htmlFor="last-name"
                    style={{ color: '#000', fontSize: '14px', marginBottom: '4px', display: 'block' }}
                  >
                    {/* Last Name */}
                    Cognome
                  </label>
                  <TextField
                    id="last-name"
                    fullWidth
                    variant="outlined"
                    size="medium"
                    InputLabelProps={{ shrink: false }}
                    // placeholder="Enter your last name"
                    placeholder="Inserisci il tuo Cognome"
                    sx={{
                      input: { color: '#000' },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '' },
                        '&:hover fieldset': { borderColor: '' },
                        '&.Mui-focused fieldset': { borderColor: '#82a2ff' },
                      },
                    }}
                    // label="Cognome"
                    name="surname"
                    value={formData.surname}
                    onChange={handleChange}
                    error={!!errors.surname}
                    helperText={errors.surname}
                    FormHelperTextProps={{
                      sx: { fontSize: '0.67rem' }, // 👈 Smaller font size
                    }}
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12}>
                  <label
                    htmlFor="email"
                    style={{ color: '#000', fontSize: '14px', marginBottom: '4px', display: 'block' }}
                  >
                    Email
                  </label>
                  <TextField
                    id="email"
                    fullWidth
                    type="email"
                    variant="outlined"
                    size="medium"
                    InputLabelProps={{ shrink: false }}
                    // placeholder="Enter your email"
                    placeholder="Inserisci la tua Email"
                    sx={{
                      input: { color: '#000' },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '' },
                        '&:hover fieldset': { borderColor: '' },
                        '&.Mui-focused fieldset': { borderColor: '#82a2ff' },
                      },
                    }}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    FormHelperTextProps={{
                      sx: { fontSize: '0.67rem' }, // 👈 Smaller font size
                    }}
                  />
                </Grid>


                {/* Phone Number (Label for both fields) */}
                <Grid item xs={12}>
                  <label
                    htmlFor="phone-number"
                    style={{ color: '#000', fontSize: '14px', marginBottom: '4px', display: 'block' }}
                  >
                    {/* Phone Number */}
                    Numero di telefono
                  </label>
                  <Grid container spacing={2}>
                    {/* Country Code */}
                    <Grid item xs={12} sm={4}>
                      <TextField
                        select
                        fullWidth
                        variant="outlined"
                        // defaultValue="+39"
                        size="medium"
                        id="country-code"
                        InputLabelProps={{ shrink: false }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: 46,
                            color: '#000',
                            '& fieldset': { borderColor: '' },
                            '&:hover fieldset': { borderColor: '' },
                            '&.Mui-focused fieldset': { borderColor: '#82a2ff' },
                          },
                          '& .MuiSelect-icon': {
                            color: '#000',
                          },
                        }}
                        // label="Numero di telefono"
                        name="dial_code"
                        value={formData.dial_code}
                        onChange={handleChange}
                      // label="Country"
                      >
                        {countries.map((option) => (
                          <MenuItem key={option.code} value={option.dial_code}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* Phone Number */}
                    <Grid item xs={12} sm={8}>
                      <TextField
                        fullWidth
                        type="tel"
                        variant="outlined"
                        // placeholder="Enter phone number"
                        placeholder="Inserisci numero di telefono"
                        size="medium"
                        id="phone-number"
                        InputLabelProps={{ shrink: false }}
                        sx={{
                          height: 56,
                          '& input': {
                            color: '#000',
                            padding: '12.5px 18px',
                          },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: '' },
                            '&:hover fieldset': { borderColor: '' },
                            '&.Mui-focused fieldset': { borderColor: '#82a2ff' },
                          },
                        }}
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        error={!!errors.phone}
                        helperText={errors.phone}
                        FormHelperTextProps={{
                          sx: { fontSize: '0.67rem' }, // 👈 Smaller font size
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Terms Note */}
                {/* By continuing, you agree to our Terms of Service and Privacy Policy. */}
                {/* <Grid item xs={12}>
                  <Typography
                    variant="caption"
                    color="#000"  // light gray text
                    textAlign="left"
                    display="block"
                  >
                    
                    {sectionContent?.terms_note || ''}
                  </Typography>
                </Grid> */}
                <Grid item xs={12}>
                  <FormControl
                    required
                    error={!!errors.privacyAccepted}
                    component="fieldset"
                    sx={{ width: '100%', mb: 1, }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.privacyAccepted}
                            onChange={handleChange}
                            name="privacyAccepted"
                            color="primary"
                          />
                        }
                        label={
                          <span style={{ fontSize: '12px', color: '#616161' }}>
                            Dichiaro di aver letto e compreso l’informativa Privacy.
                          </span>
                        }
                        sx={{ display: 'flex' }}
                      />
                    </FormGroup>
                    {errors.privacyAccepted && <FormHelperText>{errors.privacyAccepted}</FormHelperText>}
                  </FormControl>

                  <FormControl
                    required
                    error={!!errors.marketingConsent}
                    component="fieldset"
                    sx={{ width: '100%', mb: 1 }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.marketingConsent}
                            onChange={handleChange}
                            name="marketingConsent"
                            color="primary"
                          />
                        }
                        label={
                          <span style={{ fontSize: '12px', color: '#616161' }}>
                            Autorizzo il trattamento dei miei dati per finalità di marketing e per rimanere aggiornato sulle novità.
                          </span>
                        }
                        sx={{ marginBottom: '4px', display: 'flex' }}
                      />
                    </FormGroup>
                    {errors.marketingConsent && <FormHelperText>{errors.marketingConsent}</FormHelperText>}
                  </FormControl>

                </Grid>

                {/* Message Box - fixed height reserve */}
                {serverMessage && (
                  <Grid item xs={12}>
                    <Box sx={{ mb: 1 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color: messageType === 'success' ? 'green' : 'red',
                          fontWeight: 'bold',
                          textAlign: 'center',
                          fontSize: '0.8rem',
                        }}
                      >
                        {serverMessage}
                      </Typography>
                    </Box>
                  </Grid>
                )}


                {/* Login Button */}
                <Grid item xs={12}>
                  <Box textAlign="center">
                    <Button
                      variant="contained"
                      size="xl"
                      sx={{
                        px: 4,
                        py: 2,
                        minWidth: '200px',
                        fontSize: '0.9rem',
                        backgroundColor: '#4caf80',
                        color: '#fff',
                        '&.Mui-disabled': {
                          color: '#000',
                          backgroundColor: '#4caf80',
                          opacity: 0.7, // Optional: lighter shade
                        },
                        borderRadius: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1, // spacing between text and spinner
                        '&:hover': {
                          backgroundColor: '#43a173',
                        },
                      }}
                      onClick={handleSubmit}
                      disabled={loading} // ✅ Disable while loading
                    >
                      CONFERMA
                      {loading && <CircularProgress size={20} sx={{ color: '#000' }} />}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>

          </Box>
        </Box>
      </Container>
    </PageLayout>
  );
};

export default CustomSection;
